import { Pipe, PipeTransform } from '@angular/core';
import {ProjectPhoto} from "../models/project-photo";
import {map, Observable} from "rxjs";
import {ProjectPhotoService} from "../services/project-photo.service";

@Pipe({
  name: 'projectPhotoPreview',
  standalone: true
})
export class ProjectPhotoPreviewPipe implements PipeTransform {
  constructor(private projectPhotoService: ProjectPhotoService) {
  }

  transform(value: ProjectPhoto): Observable<string> {
    return this.projectPhotoService
      .thumbnail(value)
      .pipe(
        map(blob => URL.createObjectURL(blob))
      );
  }

}
